import { View, Modal, Pressable, StyleSheet } from 'react-native';
import { BasePressTooltipProps } from './BasePressTooltip.types';
import { usePressTooltipLogic } from './BasePressTooltip.logic';
import { TestIDs } from 'src/constants/testIDs.constants';
import { tooltipTestID } from 'src/helpers/testIDs.helper';

export const BasePressTooltip: React.FC<BasePressTooltipProps> = props => {
  const { TooltipContent, TooltipButton, showTooltipArrow = false, onPress, tooltipID } = props;
  const {
    triggerRef,
    handlePress,
    handleClose,
    isVisible,
    setTooltipLayout,
    tooltipStyle,
    containerStyle,
    arrowStyle,
  } = usePressTooltipLogic(props);

  return (
    <>
      <View ref={triggerRef}>
        <TooltipButton
          isContentVisible={isVisible}
          onPress={() => {
            onPress && onPress();
            handlePress();
          }}
          testID={tooltipTestID(tooltipID, TestIDs.OPEN)}
        />
      </View>

      <Modal visible={isVisible} transparent animationType="fade" onRequestClose={handleClose}>
        <Pressable style={styles.overlay} onPress={handleClose} />
        <View
          onLayout={event => setTooltipLayout(event.nativeEvent.layout)}
          style={[tooltipStyle, containerStyle]}
          testID={tooltipID}
        >
          {showTooltipArrow && <View style={arrowStyle} />}
          <TooltipContent onClose={handleClose} />
        </View>
      </Modal>
    </>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    cursor: 'auto',
  },
});
